<template>
    <modal
        name="comment-flag"
        height="auto"
        @before-open="beforeOpen"
    >
        <modal-skeleton>
            <template #heading>
                Flag Comment
            </template>
            <p>This will notify administrators that the comment is potentially inappropriate</p>
            <template #footer>
                <button
                    class="stripButton button -outline -square"
                    @click="handleClose"
                >
                    Cancel
                </button>
                <button
                    class="button -red -square"
                    @click="flagComment"
                >
                    Flag
                </button>
            </template>
        </modal-skeleton>
    </modal>
</template>

<script>
import ModalSkeleton from '../ModalSkeleton.vue';

export default {
    name: 'CommentFlagModal',
    components: {
        ModalSkeleton,
    },
    data() {
        return {
            commentId: null,
        };
    },
    methods: {
        async flagComment() {
            await this.$store.dispatch('comments/flagComment', this.commentId);
            this.handleClose();
            this.$notify({
                group: 'general',
                type: 'warn',
                title: 'Comment Flagged',
                text: 'This comment has been flagged and reported to administrators',
            });
        },
        beforeOpen(event) {
            this.commentId = event.params.commentId;
        },
        handleClose() {
            this.$modal.hide('comment-flag');
        },
    },
};
</script>
